// FROM: https://github.com/modusign/modusign-client/blob/629dd161cac7211fbe1926d026413ae56edecb34/app/src/libs/validation/checkDuplicatedContactInfo.ts

import { SignerToReference } from '@modusign/react-signing/types';
import { removeAllDash } from 'libs/formatter/removeAllDash';
import { removeAllSpace } from 'libs/formatter/removeAllSpace';
import { DeepMap, FieldError } from 'react-hook-form';

const isPhoneNumber = (v?: string) => removeAllSpace(removeAllDash(v))?.match(/^[0-9]+$/);

function checkDuplicatedContactInfo({
  signers,
  targetContact,
  signerId,
  order,
  errorMap,
}: {
  signers: Record<string, SignerToReference>;
  signerId: string;
  targetContact: string;
  order: number;
  errorMap: Record<string, boolean>;
}) {
  const otherSignersInSameOrder = Object.keys(signers)
    .filter((key) => key !== signerId)
    .filter((key) => signers[key].order === order)
    .filter((key) => !!signers[key].contact)
    .map((key) => ({
      contactInfo: signers[key].contact as string,
      id: key,
    }));

  return otherSignersInSameOrder.find((otherSigner) => {
    if (errorMap[otherSigner.id]) {
      return false;
    }

    if (isPhoneNumber(otherSigner.contactInfo) && isPhoneNumber(targetContact)) {
      const formatNumbers = (contact: string) => {
        const dashRemovedNumber = removeAllSpace(removeAllDash(contact));

        if (dashRemovedNumber?.length === 11) {
          return dashRemovedNumber?.replace(/010/, '');
        }

        return dashRemovedNumber;
      };

      return formatNumbers(otherSigner.contactInfo) === formatNumbers(targetContact);
    }

    return otherSigner.contactInfo === targetContact;
  });
}
// TODO(@DevSDK): 통합되면 하나로 합치기
export function duplicatedContactInfoValidator(param: {
  signers: Record<string, SignerToReference>;
  signerId: string;
  targetContact: string;
  order: number;
  errors: DeepMap<Record<string, SignerToReference>, FieldError>;
}) {
  const errorMap: Record<string, boolean> = {};
  Object.keys(param.errors).forEach((singerId) => {
    errorMap[singerId] = param.errors[singerId]?.contact?.type === 'isInvalid';
  });
  return checkDuplicatedContactInfo({ ...param, errorMap })
    ? '같은 연락처를 가진 서명자가 있습니다.'
    : true;
}
